export var customHeadCodeApiRelativePath = "/helpcenter/headcode";
export var createCustomHeadCodeApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(customHeadCodeApiRelativePath);
    return {
        getCustomHeadCode: function (dto) { return http.get("".concat(apiUrl, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : '')); },
        updateCustomHeadCode: function (dto) { return http.put("".concat(apiUrl, "/").concat(dto.locale), dto.data); },
    };
};
//# sourceMappingURL=index.js.map